var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileFvl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 151,
    viewBox: "0 0 122 151",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Canvas",
    transform: "translate(4478 1607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path0_fill",
    transform: "translate(-4477.06 -1606.36)",
    fill: "#D9DEE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path1_fill",
    transform: "translate(-4452.02 -1501.97)",
    fill: "#C3272F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -4447.84 -1530.41)",
    fill: "#201F1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -4436.88 -1510.32)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "file-fvl_svg__file-fvl_svg__mask0_outline_ins"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path3_fill",
    fill: "white",
    transform: "matrix(1 0 0 -1 -4436.88 -1510.32)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#file-fvl_svg__file-fvl_svg__mask0_outline_ins)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path4_stroke_2x",
    transform: "matrix(1 0 0 -1 -4436.88 -1510.32)",
    fill: "#201F1F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -4430.19 -1516.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -4430.19 -1524.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -4430.19 -1531.96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -4430.19 -1539.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path8_fill",
    transform: "matrix(1 0 0 -1 -4400.36 -1516.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path9_fill",
    transform: "matrix(1 0 0 -1 -4400.36 -1524.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path9_fill",
    transform: "matrix(1 0 0 -1 -4400.36 -1531.96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path10_fill",
    transform: "matrix(1 0 0 -1 -4400.36 -1539.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -4430.19 -1546.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path10_fill",
    transform: "matrix(1 0 0 -1 -4400.36 -1546.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-fvl_svg__file-fvl_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-fvl_svg__file-fvl_svg__path11_fill",
    transform: "matrix(1 0 0 -1 -4419.35 -1526)",
    fill: "#C3272F"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path0_fill",
    d: "M 86.4752 0L 8.6458 0C 3.876 0 -1.31138e-08 3.75657 -1.31138e-08 8.40343L -1.31138e-08 141.926C -1.31138e-08 146.568 3.876 150.33 8.6458 150.33L 112.418 150.33C 117.198 150.33 121.064 146.568 121.064 141.926L 121.064 33.6137L 86.4752 0ZM 86.4752 11.8811L 108.839 33.6137L 86.4752 33.6137L 86.4752 11.8811ZM 112.419 141.926L 8.6458 141.926L 8.6458 8.40343L 77.8276 8.40343L 77.8276 33.6137C 77.8276 38.2556 81.695 42.0171 86.4734 42.0171L 112.418 42.0171L 112.418 141.926L 112.419 141.926Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path1_fill",
    d: "M 12.6135 22C 12.2461 22 11.9371 21.8747 11.6866 21.6242C 11.4361 21.3737 11.3108 21.0648 11.3108 20.6973L 11.3108 3.73762C 11.3108 3.3535 11.4361 3.04453 11.6866 2.81072C 11.9371 2.56021 12.2461 2.43495 12.6135 2.43495L 23.9367 2.43495C 24.3208 2.43495 24.6297 2.55186 24.8636 2.78567C 25.0974 3.00278 25.2143 3.29504 25.2143 3.66246C 25.2143 4.01318 25.0974 4.29709 24.8636 4.51421C 24.6297 4.73132 24.3208 4.83987 23.9367 4.83987L 13.9161 4.83987L 13.9161 10.9273L 21.1059 10.9273C 21.4733 10.9273 21.7739 11.0442 22.0077 11.2781C 22.2582 11.4952 22.3835 11.7791 22.3835 12.1298C 22.3835 12.4805 22.2582 12.7728 22.0077 13.0066C 21.7739 13.2237 21.4733 13.3323 21.1059 13.3323L 13.9161 13.3323L 13.9161 20.6973C 13.9161 21.0648 13.7909 21.3737 13.5404 21.6242C 13.2899 21.8747 12.9809 22 12.6135 22ZM 42.8253 2.43495C 43.1927 2.43495 43.4767 2.53515 43.6771 2.73556C 43.8942 2.93598 44.0027 3.19484 44.0027 3.51215C 44.0027 3.71256 43.9526 3.92968 43.8524 4.16349L 36.4373 21.1733C 36.2201 21.7244 35.8277 22 35.2598 22C 34.7254 22 34.3329 21.7244 34.0824 21.1733L 26.7424 4.38895C 26.6088 4.03823 26.542 3.74597 26.542 3.51215C 26.542 3.17814 26.6422 2.91927 26.8426 2.73556C 27.0597 2.53515 27.352 2.43495 27.7194 2.43495C 28.3039 2.43495 28.7048 2.69381 28.9219 3.21154L 35.2348 18.3425L 41.6479 3.21154C 41.7648 2.91092 41.9151 2.71051 42.0988 2.61031C 42.2826 2.4934 42.5247 2.43495 42.8253 2.43495ZM 48.2941 22C 47.9267 22 47.6178 21.8747 47.3672 21.6242C 47.1334 21.3737 47.0165 21.0648 47.0165 20.6973L 47.0165 3.73762C 47.0165 3.3702 47.1418 3.06123 47.3923 2.81072C 47.6428 2.56021 47.9434 2.43495 48.2941 2.43495C 48.6616 2.43495 48.9705 2.56021 49.221 2.81072C 49.4716 3.06123 49.5968 3.3702 49.5968 3.73762L 49.5968 19.3947L 58.6654 19.3947C 59.0328 19.3947 59.3418 19.5199 59.5923 19.7704C 59.8428 20.0209 59.968 20.3299 59.968 20.6973C 59.968 21.0648 59.8428 21.3737 59.5923 21.6242C 59.3418 21.8747 59.0328 22 58.6654 22L 48.2941 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path2_fill",
    d: "M 4.85489 1.86879L 14.0589 0L 43.1724 22.8426L 43.8904 24.7895C 44.3474 26.3681 44.0863 28.0729 43.1724 29.4621C 42.3238 30.8512 40.8877 31.8615 39.2558 32.2403L 14.0589 38.1757C 13.602 38.302 13.0798 38.3652 12.5576 38.3652C 11.3826 38.3652 10.2729 38.0495 9.22844 37.4812C 7.79235 36.6603 6.74792 35.2712 6.35626 33.6926L 0.220234 9.31961C -0.236704 7.74105 0.0244031 6.0362 0.938279 4.64706C 1.78688 3.25793 3.22297 2.24765 4.85489 1.86879Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path3_fill",
    d: "M 7.19486 0L 40.2912 0C 44.2295 0 47.4861 3.18182 47.4861 7.19697L 47.4861 40.303C 47.4861 44.2424 44.3052 47.5 40.2912 47.5L 7.19486 47.5C 3.25662 47.5 0 44.3182 0 40.303L 0 7.19697C 0 3.25758 3.18089 0 7.19486 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path4_stroke_2x",
    d: "M 40.2912 -2.08761L 7.19486 -2.08761L 7.19486 2.08761L 40.2912 2.08761L 40.2912 -2.08761ZM 7.19486 -2.08761C 2.01307 -2.08761 -2.08761 2.11954 -2.08761 7.19697L 2.08761 7.19697C 2.08761 4.39561 4.3487 2.08761 7.19486 2.08761L 7.19486 -2.08761ZM -2.08761 7.19697L -2.08761 40.303L 2.08761 40.303L 2.08761 7.19697L -2.08761 7.19697ZM -2.08761 40.303C -2.08761 45.4849 2.11743 49.5876 7.19486 49.5876L 7.19486 45.4124C 4.39582 45.4124 2.08761 43.1515 2.08761 40.303L -2.08761 40.303ZM 7.19486 49.5876L 40.2912 49.5876L 40.2912 45.4124L 7.19486 45.4124L 7.19486 49.5876ZM 40.2912 49.5876C 45.473 49.5876 49.5737 45.3805 49.5737 40.303L 45.3985 40.303C 45.3985 43.1044 43.1374 45.4124 40.2912 45.4124L 40.2912 49.5876ZM 49.5737 40.303L 49.5737 7.19697L 45.3985 7.19697L 45.3985 40.303L 49.5737 40.303ZM 49.5737 7.19697C 49.5737 2.01515 45.3687 -2.08761 40.2912 -2.08761L 40.2912 2.08761C 43.0903 2.08761 45.3985 4.34849 45.3985 7.19697L 49.5737 7.19697Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path5_fill",
    d: "M 3.72078 0L 0 0L 0 3.59912L 3.72078 3.59912L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path6_fill",
    d: "M 3.72078 0L 0 0L 0 3.59912L 3.72078 3.59912L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path7_fill",
    d: "M 3.72078 0L 0 0L 0 3.59913L 3.72078 3.59913L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path8_fill",
    d: "M 3.72078 0L 1.99209e-06 0L 1.99209e-06 3.59912L 3.72078 3.59912L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path9_fill",
    d: "M 3.72078 0L 1.99209e-06 0L 1.99209e-06 3.59912L 3.72078 3.59912L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path10_fill",
    d: "M 3.72078 0L 1.99209e-06 0L 1.99209e-06 3.59913L 3.72078 3.59913L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-fvl_svg__file-fvl_svg__path11_fill",
    d: "M 0.718045 15.9435C 0.587491 15.9435 0.456937 15.9435 0.391661 15.8803C 0.130553 15.7541 4.98023e-07 15.5015 4.98023e-07 15.2489L 4.98023e-07 0.726139C 4.98023e-07 0.473569 0.130553 0.220998 0.391661 0.0947133C 0.652768 -0.0315718 0.913877 -0.0315718 1.10971 0.0947133L 13.3165 7.35611C 13.5123 7.48239 13.6429 7.73496 13.6429 7.98753C 13.6429 8.2401 13.5123 8.42953 13.3165 8.61896L 1.10971 15.8172C 0.979154 15.8803 0.848598 15.9435 0.718045 15.9435Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFvl);
export default __webpack_public_path__ + "static/media/file-fvl.ac7dfb4fcd2ff267fa74ccdd8b737644.svg";
export { ForwardRef as ReactComponent };